import { EtatAbsencesEnum } from "../dto/GenApi.iNotPaie.Dto/EtatAbsencesEnum";
import { NiveauValidationEnum } from "../dto/GenApi.iNotPaie.Dto/NiveauValidationEnum";
import { AbsenceActionsContext } from "../shared/interfaces/absenceActionsContext.interface";
import { AbsenceActionsState } from "../shared/interfaces/absenceActionsState.interface";

const STATUTS_ATTENTE_VALIDATION: readonly EtatAbsencesEnum[] = [
    EtatAbsencesEnum.EnAttenteValidationGestionnaire,
    EtatAbsencesEnum.EnAttenteValidationResponsableNiveau_1,
    EtatAbsencesEnum.EnAttenteValidationResponsableNiveau_2,
];

const STATUTS_ATTENTE_ANNULATION: readonly EtatAbsencesEnum[] = [
    EtatAbsencesEnum.EnAttenteAnnulationGestionnaire,
    EtatAbsencesEnum.EnAttenteAnnulationResponsableNiveau_1,
    EtatAbsencesEnum.EnAttenteAnnulationResponsableNiveau_2,
];

/**
 * | Cas | Modifier | Annuler | Supp. demande annulation |
 * |-----|----------|---------|--------------------------|
 * | En attente N1 (N1 seul)          | Visible  | Visible | Masqué  |
 * | En attente N2 (N1+N2)            | Visible grisé (si listeNiveauValideurs connu) | Visible | Masqué  |
 * | En attente N2 (N2 seul)          | Visible  | Visible | Masqué  |
 * | En attente d'annulation          | Masqué   | Masqué  | Visible |
 * | Validée                          | Masqué   | Visible | Masqué  |
 * | Validée, posée par gestionnaire  | Masqué   | Masqué  | Masqué  |
 * | Calculée / Clôturée / Refusée    | Masqué   | Masqué  | Masqué  |
 * | Annulée                          | Masqué   | Masqué  | Masqué  |
 */
export function getAbsenceActionsState(absenceContext: AbsenceActionsContext): AbsenceActionsState {
    const { etat, poseeParGestionnaire, listeNiveauValideurs, isAnonymized } = absenceContext;

    if (isAnonymized) {
        return { modifierVisible: false, modifierDisabled: true, annulerVisible: false, annulerDisabled: true, supprimerDemandeAnnulationVisible: false };
    }

    const isPendingValidation = (STATUTS_ATTENTE_VALIDATION as EtatAbsencesEnum[]).includes(etat);
    const isPendingCancellation = (STATUTS_ATTENTE_ANNULATION as EtatAbsencesEnum[]).includes(etat);

    // --- Modifier ---
    const modifierVisible =
        !poseeParGestionnaire &&
        etat !== EtatAbsencesEnum.EnAttenteValidationResponsableNiveau_2 &&
        isPendingValidation;

    const modifierDisabled =
        isPendingValidation &&
        etat === EtatAbsencesEnum.EnAttenteValidationResponsableNiveau_2 &&
        !!listeNiveauValideurs?.some(v => v === NiveauValidationEnum.Niveau_1);

    // --- Annuler ---
    const annulerDisabled =
        !!poseeParGestionnaire ||
        !(isPendingValidation || etat === EtatAbsencesEnum.Valide);

    const annulerVisible = etat !== EtatAbsencesEnum.Annule;

    // --- Supprimer demande d'annulation ---
    const supprimerDemandeAnnulationVisible =
        !poseeParGestionnaire &&
        isPendingCancellation;

    return {
        modifierVisible,
        modifierDisabled,
        annulerVisible,
        annulerDisabled,
        supprimerDemandeAnnulationVisible,
    };
}



// WEBPACK FOOTER //
// ./src/Helper/absenceActionsHelper.ts